/* eslint-disable */
import React, { useEffect, useState, useRef, useLayoutEffect, useMemo, useCallback } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import {
  Backdrop, Box, Button, Card, CardActions, Accordion,
  AccordionDetails, List, ListItem, ListItemIcon, Checkbox, ListItemText,
  AccordionSummary, CardContent, Divider, Tab, Avatar, Collapse, CircularProgress, Stack, Fade, Grid, IconButton, Link, Modal, Paper, Tooltip, Typography, Dialog, DialogTitle, DialogContent, DialogActions,
} from '@mui/material';
import 'react-circular-progressbar/dist/styles.css';
import 'react-html5video/dist/styles.css';
import { DefaultPlayer as Video } from 'react-html5video';
import { Icon } from '@iconify/react';
import Check from '@mui/icons-material/Check';
import PropTypes from 'prop-types';
import moment from 'moment';
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import VideoLabelIcon from '@mui/icons-material/VideoLabel';
import CheckIcon from '@mui/icons-material/Check';
import { ClockIcon, DocumentTextIcon, AcademicCapIcon, CheckCircleIcon, GlobeAltIcon, VideoCameraIcon, UsersIcon } from "@heroicons/react/24/outline";
import LockIcon from '@mui/icons-material/Lock';
import { LockKeyhole } from 'lucide-react';
import { useLocation, NavLink, useNavigate, useParams } from 'react-router-dom';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import GaugeChart from 'react-gauge-chart';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import Skeleton from '@mui/material/Skeleton';
import swal from 'sweetalert';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';
import { IKContext, IKImage, IKVideo } from 'imagekitio-react';
import { FaceFrownIcon, FaceSmileIcon } from '@heroicons/react/24/solid'
import SlideshowIcon from '@mui/icons-material/Slideshow';

import './index.css';
import helper from '../../../utils/helper';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import background from '../../../assets/logo/cardBackground.png';
import CardSkeleton from '../../../components/Skeleton/cardSkeleton'
import CourseContentSkeleton from '../../../components/Skeleton/CourseContentSkeleton1';
import { useTranslation } from 'react-i18next';
import BasicModal from '../../../components/modal/BasicModel';
import ButtonAnimation from '../../../components/ButtonAnimation';
import caseStudyService from '../../../services/caseStudy/caseStudyService';
import courseApi from '../../../services/users/courseApi';
import Iconify from '../../../components/Iconify';
import iqImage from '../../../assets/logo/iqImage.png';
import iqServices from '../../../services/iqTest/index';
import CourseChampion from '../../../assets/Images/new course champion.png'
import HalfwayHero from '../../../assets/Images/new halfway hero.png'
import QuarterQuest from '../../../assets/Images/new quarter quest.png'
import WelcomeChampion from '../../../assets/Images/new welcome champion.png'
import SummitConqueror from '../../../assets/Images/new summit conqueror.png';
import Page from '../../../components/Page';
import palette from '../../../theme/palette';
import { useMobileRestriction } from '../../../hooks/useResponsive';
import MobileRestrictionDialog from '../../../components/modal/MobileRestrictionDialog';
import ImageKit from '../../../settings';
import trialAndStripeSubscriptionService from '../../../services/trialAndStripeSubscriptionService';
import { openSubscriptionModal, setOpenSubscriptionModalDetails, openSnackbar } from '../../../store/reducer';
import SearchBar from './SearchBar';
import posthog from 'posthog-js';
import ListPage from './ListPage';
import { blue } from '@mui/material/colors';
import adminServices from 'src/services/adminServices';
import ReferenceScreen from '../../course/ReferenceScreen';
import loginServices from 'src/services/loginServices';
import AchivementModel from './Achivement'
import IqModel from './Iqmodel'
import { getCourseProgress, getCourseDetails1, getB2BCourseList, getB2BSAT, getCourseCompletion, getLanguageCode, getB2BNeet, getOfferbaner, getLernerView, getAssessmentList, getCognitiveAssessment, getNEETAssessment, getSubscribedAssessment, getSatDetails, getRecomdedCourseList, getBundleCourses1, getExcelDetails, getOfficeDetails, getAccFinDetails, getCodingDetails, getPowerPointDetails, getWordCourse, getCategoryDetails, getCertificateList, getAllFreeCourses, getAllcourseDetails, getDynamicCourseDetails } from '../../../Redux/Action'
import Dottedlogo from '../../../assets/Images/description_logo.png'
import { display } from '@mui/system';
import { faLessThanEqual } from '@fortawesome/free-solid-svg-icons';
import { SubscribeModal } from 'src/components/modal/SubscribeAlertModal';
import Footer from '../../../components/Footer'
import FinalImage from '../../../assets/Images/final.png';
import CourseAIAssistant from './Courseaiassistant';

const LinkBtn = React.forwardRef((props, ref) => {
  return <NavLink to={props.to} {...props} innerRef={ref} />;
});



const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#784af4',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#784af4',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
    // ...theme.applyStyles('dark', {
    //   borderColor: theme.palette.grey[800],
    // }),
  },
}));

const QontoStepIconRoot = styled('div')(({ theme }) => ({
  color: '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  '& .QontoStepIcon-completedIcon': {
    color: '#784af4',
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  // ...theme.applyStyles('dark', {
  //   color: theme.palette.grey[700],
  // }),
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        color: '#784af4',
      },
    },
  ],
}));




function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
    // ...theme.applyStyles('dark', {
    //   backgroundColor: theme.palette.grey[800],
    // }),
  },
}));

const ColorlibStepIconRoot = styled('div')(({ theme }) => ({
  backgroundColor: '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  // ...theme.applyStyles('dark', {
  //   backgroundColor: theme.palette.grey[700],
  // }),
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        backgroundImage:
          'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      },
    },
    {
      props: ({ ownerState }) => ownerState.completed,
      style: {
        backgroundImage:
          'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
      },
    },
  ],
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <SettingsIcon />,
    2: <GroupAddIcon />,
    3: <VideoLabelIcon />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

export default function UserCourseDetails(props) {
  const hasShownIqModal = useRef(false);


  const videoRef = useRef(null);
  const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id: courseId, planId: urlPlanId } = useParams();
  const userRole = useSelector((state) => state.userInfo && state.userInfo.role);
  const testrole = useSelector((state) => state);
  const userId = useSelector((state) => state.userInfo && state.userInfo.id);
  const { userSubscribedCourses } = useSelector((state) => state);
  const { openSubscriptionModalDetails, userInfo } = useSelector((state) => state);
  const allcourseDetails = useSelector((state) => state);
  const [courseDetails, setCourseDetailsState] = useState(null);
  const [courseDetailsLoading, setCourseDetailsLoading] = useState(true);
  const [caseStudy, setCaseStudy] = useState([]);
  const [courseModules, setCourseModules] = useState([]);
  const [subscription, setSubscription] = useState({});
  const [achivementModel, setAchivementModel] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(location?.state?.index && location?.state?.index)
  const [isTrialing, setIsTrialing] = useState(null);
  const prevProgressRef = useRef();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 600);
  const [showMobileRestrictionDialog, setShowMobileRestrictionDialog] = useState(false);
  const isMobile = useMobileRestriction();
  const hashTagDetails = location.state?.hashTag ? location.state.hashTag : location.state?.hashtag;
  const [courseProgress, setCourseProgress] = useState(null);
  const [csTestResult, setCsTestResult] = useState(null);
  const [csTestLoading, setCsTestLoading] = useState(false);
  const storedExpandedItem = localStorage.getItem('expandedItem');
  const initialExpanded = storedExpandedItem !== null ? Number(storedExpandedItem) : null;
  const storedSubExpandedItem = localStorage.getItem('subModuleExpandedItem');
  const initialSubmoduleExpanded = storedSubExpandedItem !== null ? Number(storedSubExpandedItem) : null;
  const [aiInitialQuestions, setAiInitialQuestions] = useState([]);
  const [aiKbStatus, setAiKbStatus] = useState('idle');
  const [expanded, setExpanded] = React.useState(null);
  console.log(courseDetails, "courseDetailscourseDetails");
  console.log(courseModules, "courseModulescourseModules");

  const [isWantMoreText, setIsWantMoreText] = useState(true);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [openContent, setOpenContent] = useState(false);
  const [openResult, setOpenResult] = useState(false);
  const [resumeData, setResumeData] = useState(null);
  const [subModuleExpanded, setSubModuleExpanded] = React.useState(initialSubmoduleExpanded);
  const [csConfig, setCsConfig] = useState(null);
  const [efficiencyVal, setEfficiencyVal] = useState(10);
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [openMobieViewError, setOpenMobileViewError] = useState(false);
  const [videoTitle, setVideoTitle] = useState({
    title: '',
    video: null,
  });
  const [searchResults, setSearchResults] = useState([]);
  const [searchComplete, setSearchComplete] = useState(false);
  const [courseComplet, setCourseComplet] = useState(false);
  const [modeldisable, setModeldisable] = useState(false);
  const [appliedFilter, setAppliedFilter] = useState('All');
  const [allBlocks, setAllBlocks] = useState([]);
  const [simBlocks, setSimBlocks] = useState([]);
  const [vidBlocks, setVidBlocks] = useState([]);
  const [slice, setSlice] = useState([]);
  const [bannerDetails, setBannerDetails] = useState('');
  const [activeStep, setactiveStep] = useState(location.state?.index ? location.state?.index : null);
  const [selectedModuleIndex, setSelectedModuleIndex] = useState(location.state?.index ? location.state?.index : 0);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [iqModel, setIqModel] = useState(false);
  const [viewComplete, setViewComplete] = useState('');
  const [IsLoading, setIsLoading] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(true);
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [moduleLoading, setModuleLoading] = useState(true);
  const [intfrequency, setintfrequency] = React.useState(1);
  const [isAtBottom, setIsAtBottom] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);
  const leftBoxRef = useRef(null);
  const [currency, setCurrency] = React.useState(userInfo?.currencyType ? userInfo?.currencyType.code : 'USD');
  const [obj, setObj] = useState([])

  const [coursetabIndex, setcourseTabIndex] = useState(
    location?.state?.tabindex !== undefined ? location.state.tabindex : 0
  );

  const [showAiPanel, setShowAiPanel] = useState(false);
  const aiKbCheckedRef = useRef(false);
  const currentDate = new Date()
  const { t } = useTranslation('translation');
  const accordionRefs = React.useRef([]);

  useEffect(() => {
    if (allcourseDetails?.AllCourseDetails?.length > 0 && courseDetails) {
      const subscribed = allcourseDetails.AllCourseDetails.filter((item) => item?.planStatus !== 'Cancel' && String(item?.id) === String(courseId));
      setSubscriptionData(subscribed[0])
    }
  }, [courseId, allcourseDetails?.AllCourseDetails, courseDetails]);

  useEffect(() => {
    if (allcourseDetails?.AllCourseDetails?.length > 0 && courseDetails) {
      const obj = allcourseDetails?.AllCourseDetails?.filter((item) => item?.planStatus !== 'Cancel' && String(item?.id) === String(courseId));
      setObj(obj)
    }
    else {
      setObj([])
    }
  }, [courseId, allcourseDetails?.AllCourseDetails, courseDetails])

  useEffect(() => {
    if (courseDetails?.index >= 0) {
      setExpanded(courseDetails.index);
      dispatch(getCourseProgress(courseId, urlPlanId || subscription?.subscriptionPlanId || courseDetails?.subscriptionPlanId || courseDetails?.subscriptionplanid, userRole))
      setTimeout(() => {
        const el = accordionRefs.current[courseDetails.index];
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });

        }
      }, 300);
    }
  }, [courseId]);

  const handleGoBack = () => {
    if (userRole === 'AUTH_USER') {
      dispatch(getB2BCourseList(userId, 'paid'))
      navigate('/app/course');
    }
    else if (location?.state?.comingfrom === "bundle") {
      navigate('/auth/bundledetails', { state: { item: location?.state?.detail } })
    }
    else if (userRole === 'USER_DTC') {
      dispatch(getCourseCompletion(userId))
      dispatch(getDynamicCourseDetails('en', userId)),
        dispatch(getAllFreeCourses('en', userId))
      dispatch(getRecomdedCourseList(userId, 'en'))
      dispatch(getAllcourseDetails('en'))
      navigate('/auth/subscribe');
    }
  }

  const [isValid, setIsvalid] = React.useState(false);
  useEffect(() => {
    if (obj && obj?.length > 0) {
      setIsvalid(new Date(obj[0]?.validTo) > currentDate)
    }

  }, [obj])
  const [selectedLesson, setSelectedLesson] = React.useState(null);

  const handleChange = (index) => {
    setExpanded(expanded === index ? null : index);
  };


  const stats = [
    { label: "Flexible Time", title: "Flexible Time", icon: ClockIcon },
    { label: "Modules", title: courseModules && courseModules?.length, icon: DocumentTextIcon },
    { label: "Course Type", title: courseDetails?.type ? courseDetails.type.charAt(0).toUpperCase() + courseDetails.type.slice(1) : "", icon: AcademicCapIcon },
    { label: "Language Used", title: "English", icon: GlobeAltIcon },
  ];

  const progressPercentage = courseProgress && parseInt(courseProgress.overallProgress, 10)


  const resultfinalAchivement = (
    courseProgress?.iqtestcount > 0 &&
    progressPercentage >= 25 &&
    progressPercentage >= 50 &&
    progressPercentage >= 75 &&
    progressPercentage === 100 &&
    courseProgress?.efficiencyScore >= 3 &&
    courseProgress?.efficiencyScore >= 4
  ) ? true : false;


  const achievements = [
    courseDetails?.is_free === false && {
      title: "Welcome Champion",
      desc: "Take First IQ Test at any time",
      unlocked: courseProgress?.iqtestcount > 0,
      icon: WelcomeChampion,
    },
    {
      title: "Quarter Quest",
      desc: "Complete 25% of the course",
      unlocked: progressPercentage >= 25,
      icon: QuarterQuest
    },
    {
      title: "Halfway Hero",
      desc: "Complete 50% of the course",
      unlocked: progressPercentage >= 50,
      icon: HalfwayHero
    },
    {
      title: "Summit Conqueror",
      desc: "Complete 75% of the course",
      unlocked: progressPercentage >= 75,
      icon: SummitConqueror
    },
    {
      title: "Course Champion",
      desc: "Complete 100% of the course",
      unlocked: progressPercentage === 100,
      icon: CourseChampion
    },
  ].filter(Boolean);

  const priceInfo = React.useMemo(() => {
    const filteredList = courseDetails?.stripePricingList
      ? courseDetails?.stripePricingList
      : courseDetails?.stripe_pricing_list?.filter(data =>
        allcourseDetails?.currency === 'USD'
          ? data?.related_currency_type_lk === 2
          : data?.related_currency_type_lk === 1
      );

    const discountPercentage = courseDetails?.discount ? parseInt(courseDetails.discount) : 0;

    if (filteredList && filteredList?.length > 0) {
      const isUSD = allcourseDetails?.currency === 'USD';
      // related_currency_type_lk: 1 = INR, 2 = USD
      const currencyRow = filteredList.find(d => isUSD ? d.related_currency_type_lk === 2 : d.related_currency_type_lk === 1)
        || filteredList[0];
      const priceValue = currencyRow.value;
      const currencySymbol = isUSD ? '$' : '₹';

      const actualPrice = `${currencySymbol}${priceValue}`;

      if (discountPercentage > 0) {
        const discountedValue = (priceValue - (priceValue * discountPercentage / 100)).toFixed(2);
        const discountedPrice = `${currencySymbol}${discountedValue}`;

        return {
          displayPrice: discountedPrice,
          actualPrice: actualPrice,
          discountPercentage: discountPercentage,
          hasDiscount: true
        };
      } else {
        return {
          displayPrice: actualPrice,
          actualPrice: actualPrice,
          discountPercentage: 0,
          hasDiscount: false
        };
      }
    } else {
      return {
        displayPrice: null,
        actualPrice: null,
        discountPercentage: 0,
        hasDiscount: false
      };
    }

  }, [allcourseDetails, courseDetails]);


  const handleCourseTabChange = (event, newValue) => {
    dispatch(getCourseProgress(courseId, urlPlanId || subscription?.subscriptionPlanId || courseDetails?.subscriptionPlanId || courseDetails?.subscriptionplanid, userRole))
    setcourseTabIndex(newValue);
  };

  useEffect(() => {
    const playVideo = async () => {
      if (videoRef.current) {
        try {
          await videoRef.current.play();
        } catch (error) {
          console.error("Autoplay failed or blocked: ", error);
        }
      }
    };

    playVideo();

    return () => {
      if (videoRef.current) {
        videoRef.current.pause();
      }
    };
  }, [videoTitle]);

  const CloseModel = () => {
    setIqModel(false);

  }


  const [milestones, setMilestones] = useState({
    crossed25: false,
    crossed50: false,
    crossed75: false,
    crossed100: false,
  });

  const OverViewTabs = [
    <Tab id="Overview-section" key="Overview" label="Overview" />,
    <Tab id="Curriculum-section" key="Curriculum" label="Curriculum" />,

    <Tab
      id="Achivements-section"
      key="Achivements"
      label="Achivements"
    />

  ]

  const CloseModelAchivement = (progress) => {
    setMilestones({
      crossed25: false,
      crossed50: false,
      crossed75: false,
      crossed100: false,
    });
    setAchivementModel(false);
    setModeldisable(true);

    const existingProgressData = JSON.parse(localStorage.getItem("progressmodelold"));
    const safeProgressData = Array.isArray(existingProgressData) ? existingProgressData : [];

    const newProgress = {
      progress: progress,
      id: courseDetails?.id,
      // progress25: progress >= 25 && progress < 50,
      // progress50: progress >= 50 && progress < 75,
      // progress75: progress >= 75 && progress < 100,
      progress100: progress === 100,
      userid: userId
    };

    const updatedProgressData = safeProgressData?.map((entry) => {
      if (entry.userid === userId && entry.id === courseDetails?.id) {
        return {
          ...entry, progress100: newProgress.progress100,
          // progress75: newProgress.progress75,
          // progress50: newProgress.progress50,
          // progress25: newProgress.progress25,
        };
      }
      return entry;
    });

    const entryExists = updatedProgressData?.some(
      (entry) => entry.userid === userId && entry.id === courseDetails?.id
    );
    const finalProgressData = entryExists ? updatedProgressData : [...updatedProgressData, newProgress];
    localStorage.setItem("progressmodelold", JSON.stringify(finalProgressData));
  }

  const oldProgress = JSON.parse(localStorage.getItem("progressmodelold"));



  React.useMemo(() => {
    const courseModulesProgress = courseModules?.map((module) => {
      const allCompleted = module.subModule?.every((subModule) => subModule.completed === 100);
      return {
        ...module,
        modelcomplete: allCompleted
      };
    });


    const modelCompleteCount = courseModulesProgress?.filter(item => item.modelcomplete === true)?.length;
    const completedModules = t("Completed Modules - ") + modelCompleteCount + " / " + courseModules?.length;
    // const completionPercentage = courseModules?.length ? ((modelCompleteCount / courseModules?.length) * 100).toFixed(1) : 0;
    const completionPercentage = courseModules?.length
      ? Math.round((modelCompleteCount / courseModules?.length) * 100)
      : 0;




    setViewComplete(`${completedModules} (${completionPercentage}%)`);
  }, [courseModules])

  useEffect(() => {
    // CloseModelAchivement();
    setIqModel(false);
    getDetails()
  }, [])

  useLayoutEffect(() => {
    setCourseProgress(allcourseDetails.CourseProgress);

    const iqTestCount = parseInt(allcourseDetails?.CourseProgress?.iqtestcount, 10);
    const overallProgress = parseInt(allcourseDetails?.CourseProgress?.overallProgress, 10);

    if ((overallProgress === 0 || overallProgress === 100) && iqTestCount === 0 && courseDetails?.is_free === false) {
      setIqModel(true);
      hasShownIqModal.current = true;
    } else if (iqTestCount >= 1) {
      setIqModel(false);
      hasShownIqModal.current = true;
    }
  }, [allcourseDetails]);

  console.log(courseDetails, "courseDetailscourseDetails");

const isModuleComplete = (module) =>
  Array.isArray(module?.subModule) &&
  module.subModule.length > 0 &&
  module.subModule.every((sm) => Number(sm.completed) >= 100);
 
const getModuleSummary = (modules) => {
  const list = Array.isArray(modules) ? modules : [];
 
  const moduleStatus = list.map((m, i) => ({
    number: i + 1,
    name: m.courseModuleName,
    completed: isModuleComplete(m),
  }));
 
  const completed = moduleStatus.filter((m) => m.completed);
  const next = moduleStatus.find((m) => !m.completed) || null; 
 
  return {
    moduleStatus, 
    completedModuleCount: completed.length,
    remainingModuleCount: list.length - completed.length,
    completedModuleNames: completed.map((m) => m.name),
    completedModulesText: completed.length ? completed.map((m) => m.name).join(', ') : 'Modules in progress',
    nextModuleNumber: next ? next.number : null, 
    nextModuleName: next ? next.name : null,
  };
};


const ProgressFunction = async () => {
  const overallProgressmodel = parseInt(allcourseDetails?.CourseProgress?.overallProgress, 10);
  const progress =
    overallProgressmodel >= 25 && overallProgressmodel <= 49 ? 25 :
      overallProgressmodel >= 50 && overallProgressmodel <= 74 ? 50 :
        overallProgressmodel >= 75 && overallProgressmodel <= 99 ? 75 :
          100;
  const date = new Date();
  const completionDate = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
  const Modules = courseModules?.length > 0 ? courseModules.map((data) => data.courseModuleName) : [];
  const moduleSummary = getModuleSummary(courseModules);
 
  const payload = {
    "firstName": userInfo?.firstName,
    "lastName": userInfo?.lastName,
    "email": userInfo?.email,
    "courseName": courseDetails?.title,
    "description": courseDetails?.description,
    "courseId": courseId,
    "enrollmentType": courseDetails?.is_free ? "Free" : "Paid",
    "completionDate": completionDate,
    "progress": progress,                      
    "overallProgress": overallProgressmodel,  
    "planID": subscription?.subscriptionPlanId || courseDetails?.subscriptionPlanId || courseDetails?.subscriptionplanid,
    "Modules": Modules,
    "Totalmodules": courseModules?.length || 0,
    ...moduleSummary,                         
  };
 
  await adminServices.CourseCompletion(payload, userInfo?.id, userRole);
  dispatch(getCourseProgress(courseId, urlPlanId || subscription?.subscriptionPlanId || courseDetails?.subscriptionPlanId || courseDetails?.subscriptionplanid, userRole));
  await getCourseDetails();
};

  React.useMemo(() => {
    if (allcourseDetails?.CourseProgress) {

      if (parseFloat(allcourseDetails.efficiencyScore) >= 10 && parseFloat(allcourseDetails.efficiencyScore) < 100) {
        setEfficiencyVal(100);
      } else if (
        parseFloat(allcourseDetails.efficiencyScore) >= 100 &&
        parseFloat(allcourseDetails.efficiencyScore) < 1000
      ) {
        setEfficiencyVal(1000);
      } else if (
        parseFloat(allcourseDetails.efficiencyScore) >= 1000 &&
        parseFloat(allcourseDetails.efficiencyScore) < 10000
      ) {
        setEfficiencyVal(10000);
      }
    }
  }, [allcourseDetails])


  const getDetails = async () => {
    const res = await adminServices.getBasicDetails();
    if (res.ok) {
      res.data?.settings?.map(item => {
        switch (item.config_name) {

          case "static_banner_message":
            setBannerDetails(item.data && item.data[0])
            break;

        }
      })

    }
  }

  const progress = courseProgress && parseInt(courseProgress.overallProgress, 10) ? courseProgress && parseInt(courseProgress.overallProgress, 10) : 0;

  const progressCalledRef = useRef(false);


  useEffect(() => {
    // if (userRole !== 'USER_DTC') return;

    const timer = setTimeout(() => {
      const progress = Number(courseProgress?.overallProgress) || 0;
      const courseStep = courseProgress?.course_progress;
      if (courseDetails?.is_free) return;

      const shouldTrigger =
        (progress >= 25 && progress < 50 && courseStep !== 25) ||
        (progress >= 50 && progress < 75 && courseStep !== 50) ||
        (progress >= 75 && progress < 100 && courseStep !== 75) ||
        (progress === 100 && courseStep !== 100);

      if (shouldTrigger && !progressCalledRef.current) {
        progressCalledRef.current = true;
          setAchivementModel(true);
          ProgressFunction();
        
      
      } else {
        setAchivementModel(false);
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [courseProgress, userRole]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === 'light' ? '#00B673' : '#00B673',
    },
  }));

  const achievementsTake = [
    courseDetails?.is_free === false && {
      id: 1,
      name: "Welcome Champion",
      unlocked: courseProgress?.iqtestcount > 0,
      message: "Take First test to unlock this medal",
      icon: WelcomeChampion,
    },
    {
      id: 2,
      name: "Quarter Quest",
      unlocked: progress >= 25,
      message: "You have completed 25% of course",
      icon: QuarterQuest,
    },
    {
      id: 3,
      name: "Halfway Hero",
      unlocked: progress >= 50,
      message: "You have completed 50% of course",
      icon: HalfwayHero,
    },
    {
      id: 4,
      name: "Summit Seeker",
      unlocked: progress >= 75,
      message: "You have completed 75% of course",
      icon: SummitConqueror,
    },
    {
      id: 5,
      name: "Perfect Strike",
      unlocked: progress === 100,
      message: "You have completed 100% of course",
      icon: CourseChampion,
    },
  ].filter(Boolean);


  useEffect(() => {
    if (!courseId) {
      navigate(userRole === 'USER_DTC' ? '/auth/subscribe' : '/app/course');
    }
  }, []);

  const SubcriptionEnable = (data) => {
    return (
      <Paper elevation={3} style={{ width: '97%', margin: '0 auto', marginLeft: '30px' }}>
        <div style={{ display: 'flex', marginTop: -30, marginBottom: 30, justifyContent: 'space-between', padding: '1rem' }}>
          <div className={classes.renewContent}>
            <Typography style={{ fontWeight: 'bold', fontSize: '18px' }} component="h2">
              {data.title}
            </Typography>
            <Typography> {data.description}</Typography>
          </div>
          <div className={classes.renewContent}>
            {userRole === 'USER_DTC' && (
              <>
                {subscription?.planStatus?.toLowerCase() === 'expired' ? (
                  <Button variant="contained" onClick={() => postSubscribeDetails(subscription?.subscriptionPlanId)}>
                    {subscription?.isTrial && 'Subscribe'}
                    {subscription?.isTrial === false && 'Renew'}
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    className={classes.subscribe}
                    onClick={() => postSubscribeDetails(subscription?.subscriptionPlanId, 'subscribeButton')}
                  >
                    Subscribe
                  </Button>
                )}
              </>
            )}
            {userRole === 'AUTH_USER' &&
              subscription?.isSubscribed &&
              subscription?.planStatus?.toLowerCase() === 'active' && (
                <Button
                  variant="contained"
                  className={classes.subscribe}
                  onClick={() => postSubscribeDetails(subscription?.subscriptionPlanId)}
                >
                  {subscription?.planStatus?.toLowerCase()}
                </Button>
              )}
          </div>
        </div>
      </Paper>



    );
  };


  const getFilterData = (masterData) => {
    const aBlocks = [];
    const sBlocks = [];
    const vBlocks = [];
    masterData?.forEach(res => {
      if (typeof (res.subModule) !== undefined && res?.subModule != null) {
        res?.subModule?.forEach(sub => {
          aBlocks.push({
            type: 'v',
            sub: sub.courseSubmoduleName,
            mod: res.courseModuleName,
            video: sub.video,
            id: sub.id
          });
          vBlocks.push({
            type: 'v',
            sub: sub.courseSubmoduleName,
            mod: res.courseModuleName,
            video: sub.video,
            id: sub.id
          });
          if (typeof (sub.subModuleTopics) !== undefined && sub.subModuleTopics != null) {
            sub.subModuleTopics.forEach(topic => {
              aBlocks.push({
                type: 's',
                topic: topic.courseSubmoduleTopics,
                sub: sub.courseSubmoduleName,
                mod: res.courseModuleName,
                tid: topic.id,
                sid: sub.id
              });
              sBlocks.push({
                type: 's',
                topic: topic.courseSubmoduleTopics,
                sub: sub.courseSubmoduleName,
                mod: res.courseModuleName,
                tid: topic.id,
                sid: sub.id
              });
            });
          }
        });
      }
    });

    setAllBlocks(aBlocks);
    setSimBlocks(sBlocks);
    setVidBlocks(vBlocks);
    setSlice(aBlocks);
    setSearchResults(slice);
  };


  const handleAiNavigateToModule = useCallback((ctx) => {
    // Switch to Curriculum tab
    setcourseTabIndex(1);

    // Small delay to let the tab render, then expand the correct accordion
    setTimeout(() => {
      const idx = ctx.module_index; // 0-based index from backend
      if (typeof idx === 'number' && idx >= 0) {
        setExpanded(idx);
        localStorage.setItem('expandedItem', idx);

        // Scroll the accordion into view
        setTimeout(() => {
          const el = accordionRefs.current[idx];
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 150);
      }
    }, 100);
  }, []);

  const postSubscribeDetailsButton = async (item) => {
    const planId = subscription?.subscriptionPlanId || item.subscriptionPlanId || item.subscriptionplanid
    const courseId = item.id;
    setIsLoading(true);

    if (item.isPaid) {
      let impactClickId = '';
      try {
        impactClickId = await helper.getClickId();
      } catch (error) {
        console.error(error);
        impactClickId = '';
      }

      const payload = {
        userId,
        courseId,
        planId,
        currencyType: currency,
        frequency: item?.frequency,
        impactClickId,
      };

      try {
        const res = await trialAndStripeSubscriptionService.createStripeSubscription(JSON.stringify(payload));
        if (res.status === 303) {
          // dispatch(closeSubscriptionModal());
          // setSubscriptionModalLoading(false);
          window.location = res.data.paymentUrl;
          setIsLoading(false);
        } else {
          if (res?.data?.message) {
            setIsLoading(false);

            dispatch(openSnackbar(res.data.message));
          } else {
            setIsLoading(false);

            dispatch(openSnackbar('Failed to Subscribe, Please try again.'));
          }
          // setSubscriptionModalLoading(false);
        }
      } catch (error) {
        setIsLoading(false);

        console.log(error);
      }
    } else {
      setIsLoading(true);
      try {
        const res = await trialAndStripeSubscriptionService.createStripeSubscription(JSON.stringify({ planId }));
        if (res.ok) {
          getCourseDetails()

          dispatch(openSnackbar('Course subscribed successfully'));
        } else if (res.status === 400) {
          dispatch(openSnackbar(res.data.message));
        } else {
          dispatch(openSnackbar('Failed to subscribe, please try again'));
        }
      } catch (error) {
        console.log(error);
        setIsLoading(false);

      }
      setIsLoading(false);
    }
  };



  const getCourseDetails = async () => {
    setModuleLoading(!courseDetails?.comingFrom ? false : true);
    const planId = urlPlanId || subscription?.subscriptionPlanId || courseDetails?.subscriptionPlanId || courseDetails?.subscriptionplanid || '';
    dispatch(getCourseDetails1(courseId, planId, allcourseDetails.languagecode))
    setLoading(false);
  };


  useEffect(() => {

    if (allcourseDetails?.CourseModuleDetails) {
      setCourseModules(allcourseDetails?.CourseModuleDetails?.course);
      setCaseStudy(allcourseDetails?.CourseModuleDetails?.files);
      setSubscription(allcourseDetails?.CourseModuleDetails?.subscription);

      // Set course details from courseInfo in API response
      if (allcourseDetails?.CourseModuleDetails?.courseInfo) {
        setCourseDetailsState({ ...allcourseDetails.CourseModuleDetails.courseInfo, id: courseId });
      }
      else {
        setCourseDetailsState(location?.state)
      }
      setCourseDetailsLoading(false);

      // Call getCourseProgress once we have the planId from API
      const apiPlanId = allcourseDetails?.CourseModuleDetails?.subscription?.subscriptionPlanId;
      if (apiPlanId) {
        dispatch(getCourseProgress(courseId, apiPlanId, userRole));
      }

      if (!allcourseDetails?.CourseModuleDetails?.subscription?.isTrial &&
        allcourseDetails?.CourseModuleDetails?.subscription?.isSubscribed) {
        if (
          allcourseDetails?.CourseModuleDetails?.subscription?.planStatus?.toLowerCase() === 'expired' ||
          allcourseDetails?.CourseModuleDetails?.subscription?.planStatus?.toLowerCase() === 'cancel'
        ) {
          if (userRole === 'USER_DTC') {
            postSubscribeDetails(allcourseDetails?.CourseModuleDetails?.subscription?.subscriptionPlanId);
          }
        }
      }

      setModuleLoading(true);
    }
  }, [allcourseDetails?.CourseModuleDetails])


  useEffect(() => {
    if (!courseDetails?.id || aiKbCheckedRef.current) return;
    aiKbCheckedRef.current = true;
    // adminServices.getInitialQuestions(courseDetails.id).then(res => {
    //   if (res.ok && res.data?.questions?.length > 0) {
    //     setAiInitialQuestions(res.data.questions);
    //     setAiKbStatus('done');
    //     setShowAiPanel(true);
    //   } else {
    //     setAiKbStatus('not_started');
    //     setShowAiPanel(false);
    //   }
    // }).catch(() => {
    //   setAiKbStatus('error');
    //   setShowAiPanel(false);
    // });
  }, [courseDetails?.id]);


  useEffect(() => {
    if (courseModules && courseModules.length > 0) {
      getFilterData(courseModules);
    }
  }, [courseModules]);

  const getLastCompletedDetails = async () => {
    const res = await courseApi.getUserLastCompletedDetails(courseId);
    if (res.ok) {
      setResumeData(res.data);
    }
  };

  const postSubscribeDetails = async (planId, subscribeButton) => {
    const postedCourses = JSON.parse(sessionStorage.getItem("postedSubscribeCourses") || "[]");
    if (postedCourses.includes(planId) && subscribeButton === undefined) return;
    dispatch(setOpenSubscriptionModalDetails(courseDetails));
    dispatch(openSubscriptionModal(planId));
    postedCourses.push(planId);
    sessionStorage.setItem("postedSubscribeCourses", JSON.stringify(postedCourses));
  };
  const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: expanded === expand ? 'rotate(180deg)' : 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  }));

  const ExpandMoreSub = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: subModuleExpanded === expand ? 'rotate(180deg)' : 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  }));

  useEffect(() => {
    if (!courseId) return;
    getLastCompletedDetails();
    getCourseDetails();
    getCaseStudyResult();
    getCaseStudyConfig();
    // const planId = urlPlanId || courseDetails?.subscriptionPlanId || courseDetails?.subscriptionplanid;
    // if (planId) {
    //   dispatch(getCourseProgress(courseId, planId));
    // }
  }, [courseId]);


  // useEffect(()=>{
  //   getCourseDetails();
  // },[allcourseDetails.languagecode,courseDetails])

  const getCaseStudyResult = () => {
    try {
      caseStudyService.getCaseStudyResult(courseId).then((res) => {
        if (res.ok) {
          if (Object.keys(res.data).length > 0) {
            setCsTestResult(res.data);
          }
          setCsTestLoading(true);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getCaseStudyConfig = () => {
    caseStudyService.getCaseStudyConfig(courseId).then((response) => {
      if (response.ok && response.status === 200) {
        if (Object.keys(response.data).length > 0) {
          setCsConfig(response.data);
        }
      }
    });
  };

  const moduleRefs = useRef([]);
  useEffect(() => {
    if (activeStep !== null && moduleRefs.current[activeStep]) {
      moduleRefs.current[activeStep].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

  }, [activeStep, loading]);


  const handleExpandClick = (i) => {
    if (expanded === i) {
      setExpanded(-1);
      setSubModuleExpanded(null);
      localStorage.setItem('expandedItem', -1);
    } else {
      setSubModuleExpanded(null);
      localStorage.setItem('subModuleExpandedItem', -1);
      setTimeout(() => {
        setExpanded(i);
        localStorage.setItem('expandedItem', i);
      }, 300);
    }
  };

  const handleSubModuleExpandClick = (i) => {
    const isExpandingSameSubModule = subModuleExpanded === i;

    setSubModuleExpanded(isExpandingSameSubModule ? -1 : i);

    setTimeout(() => {
      if (!isExpandingSameSubModule) {
        setSubModuleExpanded(i);
      }
    }, 300);

    localStorage.setItem('subModuleExpandedItem', isExpandingSameSubModule ? -1 : i);
  };
  const handleClickTrialButton = async (planId, enrollmentType, courseDetails) => {
    try {
      const res = await trialAndStripeSubscriptionService.postTrialCourseEnrollmentDetails(
        JSON.stringify({ planId: planId, enrollmentType: enrollmentType, courseId: courseDetails?.id })
      );
      if (res.ok) {
        console.log('responec succes', res);

      }
    } catch (error) {
      console.log(error);
    }
    setIsTrialing(null);
  };

  const handleStartSimulation = (subModuleId, module, selectindex, courseModules, resumeClic = false) => {
    const isVideoType = String(courseDetails?.type).toLowerCase() === 'video';

    posthog.capture('course_content_viewed', {
      course_id: courseDetails?.id || courseDetails?.courseId,
      course_name: courseDetails?.title || courseDetails?.courseName,
      module_name: module,
      sub_module_id: subModuleId,
    });

    if (isMobile && !isVideoType) {
      setShowMobileRestrictionDialog(true);
      return;
    }
    const planId = urlPlanId || subscription?.subscriptionPlanId || courseDetails?.subscriptionPlanId || courseDetails?.subscriptionplanid;

    const selectedModuleDetails = courseModules[expanded]?.subModule;
    if (isSmallScreen && !isVideoType) {
      setOpenMobileViewError(true)
    }

    if (resumeData === null && courseDetails?.is_free) {
      handleClickTrialButton(planId, courseDetails?.is_free, courseDetails)
    }
    if (resumeData && resumeClic) {
      if (userRole === 'USER_DTC') {
        navigate(
          `/auth/course-simulation?module=${resumeData.Modulename}&id=${subModuleId}&topic=${resumeData.courseSubModuleTopicId}&screen=${resumeData.courseSubModuleTopicScreenId}`,
          { replace: true, state: { ...courseDetails, selectindex: selectindex, courseSubModuleDetails: selectedModuleDetails, lastModulecheck: courseModules, planId } }



        );
      } else {
        navigate(
          `/app/course-simulation?module=${resumeData.Modulename}&id=${subModuleId}&topic=${resumeData.courseSubModuleTopicId}&screen=${resumeData.courseSubModuleTopicScreenId}`,
          { replace: true, state: { ...courseDetails, selectindex: selectindex, courseSubModuleDetails: selectedModuleDetails, lastModulecheck: courseModules, planId } }
        );
      }
    } else {
      if (userRole === 'USER_DTC') {
        navigate(`/auth/course-simulation?id=${subModuleId}&module=${module}`, { replace: true, state: { ...courseDetails, selectindex: selectindex, courseSubModuleDetails: selectedModuleDetails, lastModulecheck: courseModules, planId } });
      } else {
        navigate(`/app/course-simulation?id=${subModuleId}&module=${module}`, { replace: true, state: { ...courseDetails, selectindex: selectindex, courseSubModuleDetails: selectedModuleDetails, lastModulecheck: courseModules, planId } });
      }
    }
  };


  const handleIQstart = (type) => {
    if (isMobile) {
      setShowMobileRestrictionDialog(true);
      return;
    }

    if (courseDetails?.is_free) {
      alert(t("Sorry! The SkillsetIQ feature is not available for Free Course."))
      return
    }

    if ((subscriptionData?.isSubscribed || userRole === 'AUTH_USER') && subscriptionData?.planStatus !== 'Cancel') {
      const keyType = courseModules[0]?.subModule[0]?.subModuleTopics[0]?.actionType
      if (type === 'COURSE') {
        if (userRole === 'USER_DTC') {
          navigate(`/auth/skilliq-test?courseId=${courseDetails?.id}`, {
            replace: true,
            // state: { ...courseDetails, ...keyType,subModule },
            state: { ...courseDetails, keyType },

          });
        } else {
          navigate(`/app/skilliq-test?courseId=${courseDetails?.id}`, {
            replace: true,
            state: { ...courseDetails, keyType },

            // state: { ...courseDetails, ...keyType ,subModule},
          });
        }
      }
    }
    else {
      alert(t("Please subscribe to unlock the IQ Test"))
    }
  };

  const handleIQstartVideo = (type) => {
    if (isMobile) {
      setShowMobileRestrictionDialog(true);
      return;
    }

    if (courseDetails?.is_free) {
      alert(t("Sorry! The SkillsetIQ feature is not available for Free Course."))
      return
    }


    if ((subscriptionData?.isSubscribed || userRole === 'AUTH_USER') && subscriptionData?.planStatus !== 'Cancel') {
      const keyType = 'VIDEO';
      if (type === 'COURSE') {
        if (userRole === 'USER_DTC') {
          navigate(`/auth/skilliq-test?courseId=${courseDetails.id}`, {
            replace: true,
            state: { ...courseDetails, keyType },
          });
        } else {
          navigate(`/app/skilliq-test?courseId=${courseDetails.id}`, {
            replace: true,
            state: { ...courseDetails, keyType },
          });
        }
      }
    }
    else {
      alert(t("Please subscribe to unlock the IQ Test"))
    }
  };

  async function downloadURI(url, filename) {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      })
      .catch(console.error);
  }


  const downloadURINew = (url) => {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  const fileIcon = [
    { type: 'image/jpeg', icon: 'ant-design:file-image-outlined' },
    { type: 'image/png', icon: 'ant-design:file-image-outlined' },
    { type: 'image/jpg', icon: 'ant-design:file-image-outlined' },
    { type: 'image/svg+xml', icon: 'ant-design:file-image-outlined' },
    { type: 'application/pdf', icon: 'fa6-regular:file-pdf' },
    { type: 'video/mp4', icon: 'la:file-video-solid' },
    { type: 'text/csv', icon: 'teenyicons:csv-outline' },
    { type: 'application/octet-stream', icon: 'teenyicons:xls-outline' },

    { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', icon: 'teenyicons:xls-outline' },
  ];



  const takeCaseStudyTestHandle = () => {
    if (courseProgress && parseInt(courseProgress.overallProgress, 10) < 100) {
      swal({
        // title: 'Good job!',
        text: 'You must complete 100% to be eligible to take the test',
        // icon: 'success',
        buttons: {
          confirm: {
            text: 'Okay',
            value: true,
            visible: true,
            className: '',
            closeModal: true,
          },
          // cancel: {
          //   text: 'Cancel',
          //   value: null,
          //   visible: true,
          //   className: '',
          //   closeModal: true,
          // },
        },
        closeOnClickOutside: false,
      });
    } else {
      swal({
        // title: 'Good job!',
        text: ' You have only one chance to pass the test. Please make sure that you have prepared well',
        // icon: 'success',
        buttons: {
          confirm: {
            text: 'Okay',
            value: true,
            visible: true,
            className: '',
            closeModal: true,
          },
          cancel: {
            text: 'Cancel',
            value: null,
            visible: true,
            className: '',
            closeModal: true,
          },
        },
        closeOnClickOutside: false,
      }).then((res) => {
        if (res) {
          const keyType = { actionType: courseModules[0]?.subModule[0]?.subModuleTopics[0]?.actionType };
          navigate(
            userRole === 'USER_DTC'
              ? `/auth/case-studyiq-test?courseId=${courseDetails?.id}`
              : `/app/case-studyiq-test?courseId=${courseDetails?.id}`,
            {
              replace: true,
              state: { ...courseDetails, ...keyType },
              // state: { ...courseDetails, ...keyType,subModule},
            }
          );
        }
      });
    }
  };

  const CaseStudyHtml = () => {
    return (
      <>
        {csConfig?.status === 'ACTIVE' && (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={9}>
              <Paper elevation={2} sx={{ padding: '1.4rem', marginTop: '1rem' }}>
                <Box className={classes.courserContent}>
                  <Typography variant="h6" className="casestudy">
                    Case Study
                  </Typography>
                </Box>

                {caseStudy.length === 0 && (
                  <Typography align="center" variant="subtitle1">
                    Files are not available
                  </Typography>
                )}

                {caseStudy.map((res, index) => (
                  <Box className={classes.fileList}>
                    <Link underline="none" variant="subtitle1" sx={{ display: 'flex' }} href={res.url} target="_blank">
                      {fileIcon.map((item) => {
                        return <>{res.type === item.type ? <Iconify icon={item.icon} width={20} height={20} /> : ''}</>;
                      })}
                      &nbsp; {res.name}
                    </Link>



                    {res?.type === 'image/jpeg' ||
                      res?.type === 'image/png' ||
                      res?.type === 'image/jpg' ||
                      res?.type === 'image/svg+xml' ||
                      res?.type === 'application/pdf' ||
                      res?.type === 'video/mp4' ? (
                      <IconButton size="small" onClick={() => downloadURI(res.url, res.type)}>
                        <CloudDownloadIcon color="primary" />
                      </IconButton>
                    ) : (
                      <Link
                        underline="none"
                        variant="subtitle1"
                        sx={{ display: 'flex' }}
                        href={res.url}
                        target="_blank"
                      >
                        <IconButton size="small">
                          <CloudDownloadIcon color="primary" />
                        </IconButton>
                      </Link>
                    )}
                  </Box>
                ))}


                {csTestLoading && (
                  <Box mt={3}>
                    {csTestResult ? (
                      <Button variant="contained" color="primary" onClick={() => setOpenResult(true)}>
                        View result
                      </Button>
                    ) : (
                      <>
                        {csConfig?.status === 'ACTIVE' && (
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={() => {
                              takeCaseStudyTestHandle();
                            }}
                          >
                            Take Test
                          </Button>
                        )}
                      </>
                    )}
                  </Box>
                )}

              </Paper>
            </Grid>
          </Grid>
        )}
      </>
    );
  };

  const ProgressBar = ({ progressPercentage, achivementprogress }) => {

    const steps = [
      { unlocked: achivementprogress > 0 ? true : false, bordercolor: achivementprogress > 0 ? true : false, icon: achivementprogress > 0 ? require('../../../assets/Images/Medal1_green.png') : require('../../../assets/Images/Medal1_grey.png') },
      { unlocked: progressPercentage >= 25 ? true : false, bordercolor: progressPercentage >= 25 ? true : false, icon: progressPercentage >= 25 ? require('../../../assets/Images/Medal2_green.png') : require('../../../assets/Images/Medal2_grey.png') },

      { unlocked: progressPercentage >= 50 ? true : false, bordercolor: progressPercentage >= 50 ? true : false, icon: progressPercentage >= 50 ? require('../../../assets/Images/Medal3_green.png') : require('../../../assets/Images/Medal3_grey.png') },
      { unlocked: progressPercentage >= 75 ? true : false, bordercolor: progressPercentage >= 75 ? true : false, icon: progressPercentage >= 75 ? require('../../../assets/Images/Medal4_green.png') : require('../../../assets/Images/Medal4_grey.png') },
      { unlocked: progressPercentage === 100 ? true : false, bordercolor: progressPercentage === 100 ? true : false, icon: progressPercentage === 100 ? require('../../../assets/Images/Medal5_green.png') : require('../../../assets/Images/Medal5_grey.png') },
    ];

    const getIconStyle = (index) => ({
      width: '60px',
      height: '60px',
    });

    const getSegmentWidth = (index) => {
      const lowerBound = index * 25;
      const upperBound = (index + 1) * 25;

      if (progressPercentage >= upperBound) {
        return '100%';
      } else if (progressPercentage > lowerBound) {
        const percentageInSegment = ((progressPercentage - lowerBound) / 25) * 100;
        return `${percentageInSegment}%`;
      }
      return '0%';
    };

    const getSegmentColor = (index) => {
      const upperBound = (index + 1) * 25;
      return progressPercentage >= upperBound ? '#4caf50' : '#e0e0e0';
    };

    const getIconBorderColor = (index) => {
      const upperBound = (index + 1) * 25;
      return progressPercentage >= upperBound ? '#4caf50' : '#000';
    };



    return (
      <Box className="barGraph" sx={{ width: { xs: '95%', md: '98%' }, backgroundColor: '#f9f9f9' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            {steps.map((step, index) => (
              <React.Fragment key={index}>
                <Box sx={{ textAlign: 'center', position: 'relative', flex: 1 }}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '80px',
                      height: '80px',

                      overflow: 'hidden',
                      position: 'relative',
                    }}
                  >
                    <Avatar
                      src={step.icon}
                      sx={{
                        width: '80px',
                        height: '80px',
                        opacity: step.unlocked ? 1 : 0.4,
                        transition: 'opacity 0.3s ease',
                      }}
                    />
                  </Box>

                  {step.unlocked && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 1.5,
                        right: 1,
                        backgroundColor: 'green',
                        color: '#fff',
                        borderRadius: '50%',
                        padding: '4px',
                        border: '2px solid white',
                        width: '22px',
                        height: '22px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 0 5px rgba(0, 128, 0, 0.4)',
                      }}
                    >
                      <CheckIcon sx={{ fontSize: '16px', color: 'white' }} />
                    </Box>
                  )}
                </Box>


                {index < steps.length - 1 && (
                  <Box
                    sx={{
                      height: 2,
                      width: '130%',
                      backgroundColor: '#e0e0e0',
                      position: 'relative',
                    }}
                  >
                    <Box
                      sx={{
                        height: 2,
                        width: getSegmentWidth(index),
                        backgroundColor: getSegmentColor(index),
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        borderStyle: progressPercentage >= (index + 1) * 25
                          ? '1px solid green'
                          : (
                            progressPercentage > index * 25 && progressPercentage < (index + 1) * 25
                          )
                            ? 'dashed'
                            : "",

                        transition: 'width 0.3s ease-in-out',
                      }}
                    />
                  </Box>
                )}
              </React.Fragment>
            ))}
          </Box>
        </Box>

      </Box>
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 600);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const typographyStyle = {
    fontFamily: 'Poppins',
    color: '#000',
    fontWeight: '600',
    fontSize: isSmallScreen ? '20px' : '32px',
  };




  const handleScroll = () => {
    if (leftBoxRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = leftBoxRef.current;
      const atBottom = scrollTop + clientHeight >= scrollHeight - 1;
      setIsAtBottom(atBottom);

      const scrollableHeight = scrollHeight - clientHeight;
      const halfwayPoint = scrollableHeight / 2;

      const isBelowHalf = scrollTop >= halfwayPoint;
      setIsAtBottom(isBelowHalf);
    }
  };

  useEffect(() => {
    handleScroll();
  }, []);


  useEffect(() => {
    const box = leftBoxRef.current;
    if (!box) return;

    const handleManualScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = box;
      const atBottom = scrollTop + clientHeight >= scrollHeight - 1;
      setIsAtBottom(atBottom);
    };

    box.addEventListener('scroll', handleManualScroll);

    return () => {
      box.removeEventListener('scroll', handleManualScroll);
    };
  }, []);

  useEffect(() => {
    const box = leftBoxRef.current;
    if (!box) return;

    box.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => box.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToBottom = () => {
    setIsScrolling(true);

    if (isAtBottom) {
      leftBoxRef.current?.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      leftBoxRef.current?.scrollTo({
        top: leftBoxRef.current.scrollHeight,
        behavior: 'smooth'
      });
    }

    setTimeout(() => {
      setIsScrolling(false);
      if (leftBoxRef.current) {
        const { scrollTop } = leftBoxRef.current;
        setIsAtBottom(scrollTop > 0);
      }
    }, 1100);
  };

  if (courseDetailsLoading) {
    return (
      <Page title={'Course-details'}>
        <Box sx={{ p: 3 }}>
          <Skeleton variant="rectangular" width="100%" height={350} sx={{ borderRadius: 2, mb: 3 }} />
          <Skeleton variant="text" width="60%" height={40} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="80%" height={20} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="40%" height={20} sx={{ mb: 3 }} />
          <Grid container spacing={2}>
            {[1, 2, 3, 4].map((i) => (
              <Grid item xs={6} md={3} key={i}>
                <Skeleton variant="rectangular" height={100} sx={{ borderRadius: 2 }} />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Page>
    );
  }

  return (
    <Page title={'Course-details'}>



      <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} className={classes.coursecard}>
        <Grid container>
          <div className="relative w-full h-[350px]  overflow-hidden">
            <img src={courseDetails?.thumb_img_url ? courseDetails?.thumb_img_url : courseDetails?.coverageImage} alt="Course Cover" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent" />
            <div className="absolute top-6 left-14 text-white space-y-3 max-w-[96%] mt-6">
              <button onClick={handleGoBack} className="text-sm flex items-center gap-2 hover:underline">
                ← Back
              </button>
              <h1 className="text-3xl font-bold leading-snug">
                {courseDetails?.title}
              </h1>


              <p className="text-sm md:text-base opacity-90" dangerouslySetInnerHTML={{ __html: courseDetails?.description }}></p>

              <div className="flex items-center gap-6 text-sm">
                <div className="flex items-center gap-1">
                  ⭐ <span>4.8</span>
                </div>
                <div className="flex items-center gap-1">
                  <UsersIcon className="w-5 h-5 text-[#fff]" /><span>500</span>
                </div>
              </div>

            </div>
          </div>




        </Grid>


      </Box>



      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        sx={{
          '.css-moysu4': {
            border: 'none ! important',
          },
        }}
      >
        <Fade in={open}>
          {courseDetails?.introVideo && (
            <Box className={classes.vediobox}>
              <Video controls={['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen']}>
                <source src={courseDetails?.introVideo} type="video/webm" />
                <track label="English" kind="subtitles" srcLang="en" src={courseDetails?.introVideo} default />
              </Video>
            </Box>
          )}
        </Fade>
      </Modal>

      <div className="mt-4 mb-4 px-1 sm:px-2 md:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:justify-between">

          <div className="
                grid
                grid-cols-2
                gap-2

                bg-gray-100
                rounded-xl
                p-1

               w-full
                sm:w-full
                md:w-[700px]

                grid-cols-3
                md:grid-cols-3
                md:gap-0
              ">
            {OverViewTabs.map((tab, index) => {
              // const isAchievements = tab.key === "Achivements";
              // const isDisabled = userRole === "AUTH_USER" && isAchievements;
              const isDisabled = false;
              return (

                <Tooltip
                  title={isDisabled ? "Unable to access right now : (" : ""}
                  disableHoverListener={!isDisabled}
                >
                  <span>
                    <button
                      key={index}
                      disabled={isDisabled}
                      onClick={(e) => {
                        if (!isDisabled) {
                          handleCourseTabChange(e, index);
                        }
                      }}
                      className={`
        flex items-center justify-center
        h-10 px-3
        text-xs sm:text-sm md:text-base
        rounded-md
        transition-all duration-200

        ${coursetabIndex === index
                          ? "bg-white shadow-sm text-black border border-gray-200 font-medium"
                          : "text-gray-500 hover:text-black"
                        }

        ${isDisabled
                          ? "opacity-50 cursor-not-allowed"
                          : "cursor-pointer"
                        }
      `}
                    >
                      {tab}
                    </button>
                  </span>
                </Tooltip>
              );
            })}


          </div>

        </div>
      </div>

      <AchivementModel achivementModel={achivementModel} progress={courseProgress && parseInt(courseProgress.overallProgress, 10)} handlCloseBack={CloseModelAchivement} />

      {!isMobile && <IqModel openmodel={iqModel} userRole={userRole} subscription={subscription} courseDetails={courseDetails} courseModules={courseModules} progress={courseProgress} handlCloseBack={CloseModel} subscriptionvalue={subscription} />}

      <BasicModal openModel={openContent} closeModel={() => setOpenContent(!openContent)} title={courseDetails?.title}>
        <Typography id="transition-modal-title" variant="subtitle1" component="h2">
          Description
        </Typography>
        <Typography id="transition-modal-description" sx={{ mt: 2 }}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla in tortor a ex dictum commodo. Fusce pretium,
          quam a egestas dictum, purus erat sodales nibh, eget sollicitudin urna felis non felis.
        </Typography>
      </BasicModal>

      <Grid container className={classes.CourseContentSec} mt={2} sx={{ marginLeft: '15px' }}>

        {userRole === 'AUTH_USER' &&
          subscription?.isSubscribed &&
          subscription?.planStatus?.toLowerCase() === 'cancel' && (
            <Grid item xs={12}>
              <SubcriptionEnable
                title="Your subscription has been cancelled."
                description="Kindly contact admin support."
              />
            </Grid>
          )}
        {userRole === 'AUTH_USER' &&
          subscription?.isSubscribed &&
          subscription?.planStatus?.toLowerCase() === 'expired' && (
            <Grid item xs={12}>
              <SubcriptionEnable
                title="Your subscription has expired."
                description="To renew your subscription, please contact admin support."
              />
            </Grid>
          )}
        {coursetabIndex === 0 &&
          <>
            <div className="grid gap-6 w-full grid-cols-1 sm:grid-cols-2 md:grid-cols-[repeat(auto-fit,minmax(250px,1fr))]">
              {stats?.map((item, index) => {
                const Icon = item.icon;

                return (
                  <div key={index}
                    className="bg-[rgba(255,255,255,0.15)] backdrop-blur-md rounded-2xl p-6 
                  flex flex-col items-start text-left shadow-md 
                  hover:bg-[rgba(255,255,255,0.25)] transition-all duration-500"
                  >
                    <Icon className="w-6 h-6 mb-3 text-black" />
                    <span className="text-4.5xl font-bold">{item.value}</span>
                    <span className="text-4xl font-bold">{item?.title}</span>
                    <p className="mt-2 text-sm opacity-90">{item.label}</p>
                  </div>
                );
              })}


            </div>

            <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6 w-full">

              <div className="md:col-span-2 border rounded-xl p-6 bg-white shadow-sm">
                <h2 className="text-lg font-semibold mb-2">About This Course</h2>
                <p className="text-sm text-gray-600 mb-5" dangerouslySetInnerHTML={{ __html: courseDetails?.description }}></p>
                <h3 className="text-sm font-medium mb-3">What you'll learn</h3>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3">
                  {courseDetails?.short_desc?.length > 0 ? (
                    courseDetails.short_desc.map((item, i) => (

                      <div key={i} className="flex items-center gap-2 text-sm text-gray-700">
                        <CheckCircleIcon className="w-5 h-5 text-[#32D74B]" />
                        <span>{item}</span>
                      </div>

                    ))
                  ) : (
                    <p className="text-gray-400 text-sm">No details available</p>
                  )}
                </div>
              </div>

              <div className="border rounded-xl p-6 bg-white shadow-sm flex flex-col justify-between">
                <div>
                  {((obj?.length === 0 || (obj?.length === 0 && obj[0]?.isSubscribed === false) || isValid === false) && courseDetails?.is_free !== true && !subscription?.isSubscribed && userRole !== 'AUTH_USER') ?

                    <div className="mb-4">
                      {/* Show discount percentage badge at top if available */}
                      {priceInfo.hasDiscount && (
                        <div className="mb-2">
                          <span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs font-semibold">
                            {priceInfo.discountPercentage}% OFF
                          </span>
                        </div>
                      )}

                      {/* Show actual price and discounted price on same line */}
                      {priceInfo.displayPrice && <div className="flex items-center gap-3">
                        <h3 className="text-lg font-semibold text-blue-600">{priceInfo.displayPrice}</h3>
                        {priceInfo.hasDiscount && (
                          <span className="text-gray-500 line-through text-base">{priceInfo.actualPrice}</span>
                        )}
                      </div>}
                    </div>
                    :
                    (
                      (userRole === 'AUTH_USER' || courseDetails?.is_free) ? "" : <p className="text-lg text-green-600 font-semibold mb-4">• Purchased</p>
                    )
                  }

                  {(obj && obj?.length === 0 || obj?.length === 1 && obj[0]?.isSubscribed === false) && courseDetails?.is_free === false && userRole !== 'AUTH_USER' && courseDetails?.comingfrom !== "bundle" ? '' : <h3 className="text-lg font-semibold mb-4">{courseDetails?.comingfrom !== "bundle" ? '' : ''}</h3>}

                  {(obj && obj?.length === 0 && obj[0]?.isSubscribed === false || isValid === false) && courseDetails?.is_free !== true && !subscription?.isSubscribed && userRole !== 'AUTH_USER' ?
                    <button onClick={() => postSubscribeDetailsButton(courseDetails)} className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg text-sm mb-5">
                      {IsLoading ? t("Please wait...") : t("Enroll Now")}
                    </button>
                    :
                    (
                      parseInt(courseProgress?.overallProgress, 10) === 100 ?
                        <button
                          onClick={(e) => handleCourseTabChange(e, 1)}
                          className="
                                w-full
                                bg-white
                                border
                                border-blue-600
                                text-blue-600
                                py-2
                                rounded-lg
                                text-sm
                                mb-5
                                transition
                              "
                        >
                          Watch again
                        </button>
                        :
                        <button onClick={(e) => handleCourseTabChange(e, 1)} className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg text-sm mb-5">
                          {parseInt(courseProgress?.overallProgress, 10) > 0 ? 'Continue Learning' : 'Start Learning'}
                        </button>
                    )


                  }


                  <div className="space-y-3 text-sm">

                    <div className="flex justify-between text-gray-700">
                      <span>SkillsetIQ</span>
                      <span className="font-medium">Included</span>
                    </div>

                    {(obj && obj?.length === 0 || obj?.length === 1 && obj[0]?.isSubscribed === false) && courseDetails?.is_free === false && userRole !== 'AUTH_USER' ?
                      "" :
                      <>

                        {(userRole === 'USER_DTC' && courseDetails?.is_free === false) &&
                          <div className="flex justify-between text-gray-700">
                            <span>Enrolled on</span>
                            <span className="font-medium">{obj && obj?.length > 0 && moment(obj[0]?.validFrom).format("LL")}</span>
                          </div>}
                      </>
                    }

                    {(userRole === 'USER_DTC' && courseDetails?.is_free === false) &&
                      <div className="flex justify-between text-gray-700">
                        <span>Certificate</span>
                        <span className="font-medium">Included</span>
                      </div>}
                  </div>
                </div>
              </div>
            </div>

          </>
        }

        {coursetabIndex === 1 &&
          <>
            <div className="flex gap-6 w-full items-start" style={{ height: 'calc(100vh - 145px)' }}>
              <div
                className={`flex flex-col gap-6 min-w-0 overflow-y-auto overflow-x-hidden h-full pb-6 w-full ${showAiPanel ? 'md:w-[40%]' : ''}`}
                style={{ flexShrink: 0 }}
                ref={leftBoxRef}
                onScroll={handleScroll}
              >


                <div className="mb-6 grid grid-cols-1 gap-6 w-full">
                  <div className="col-span-full border rounded-xl p-6 bg-white shadow-sm">
                    <div className="flex items-start justify-between mb-8">
                      <div>
                        <h2 className="text-2xl font-semibold text-gray-900 mb-1">
                          Achievement Progress
                        </h2>
                        <p className="text-sm text-gray-500">
                          Check "Achievements" tab above for more info
                        </p>
                      </div>
                      <div className="flex items-center gap-2 bg-green-50 px-3 py-1.5 rounded-lg">
                        <FaceSmileIcon className="w-6 h-6 text-[#2EC444]" />
                        <span className="text-sm font-semibold text-green-600">{parseInt(courseProgress?.overallProgress, 10)}%</span>
                      </div>
                    </div>

                    <div className="relative px-6">
                      <div className="absolute top-6 left-0 right-0 flex items-center">
                        <div className="w-1/10"></div>
                        <div className="flex-1 h-0.5 bg-gray-200 relative">
                          <div
                            className="h-full bg-blue-500 transition-all duration-300"
                            style={{ width: `${progressPercentage}%` }}
                          ></div>
                        </div>
                        <div className="w-1/10"></div>
                      </div>
                      <div
                        className="grid gap-2 relative"
                        style={{
                          gridTemplateColumns: `repeat(${achievementsTake.length}, minmax(0, 1fr))`,
                        }}
                      >
                        {achievementsTake?.map((achievement) => (
                          <Tooltip key={achievement.id} title={achievement.message} arrow>
                            <div className="flex flex-col items-center flex-1">
                              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-3 z-10 transition-colors duration-300 bg-gray-200">
                                {achievement.unlocked ? (
                                  <Avatar
                                    src={achievement.icon}
                                    sx={{
                                      width: "80px",
                                      height: "80px",
                                      opacity: achievement.unlocked ? 1 : 0.4,
                                      transition: "opacity 0.3s ease",
                                    }}
                                  />
                                ) : (
                                  <LockKeyhole className="w-5 h-5 text-gray-400" />
                                )}
                              </div>

                              <p className="text-xs text-center text-gray-600 leading-tight max-w-[90px]">
                                {achievement.name}
                              </p>
                            </div>
                          </Tooltip>
                        ))}
                      </div>

                    </div>

                    {courseDetails?.is_free === false && <div className="mt-8 ml-24">
                      {courseProgress && parseInt(courseProgress?.iqtestcount, 10) > 0 ?
                        <button onClick={() => handleIQstart('COURSE')} className="bg-blue-500 hover:bg-blue-600 text-white text-sm font-medium px-5 py-2 rounded-lg transition-colors">
                          Re Take IQ Test
                        </button>
                        :
                        <button onClick={() => handleIQstart('COURSE')} className="bg-blue-500 hover:bg-blue-600 text-white text-sm font-medium px-5 py-2 rounded-lg transition-colors">
                          Take IQ Test
                        </button>
                      }
                    </div>}
                  </div>
                </div>


                <Box sx={{ p: 3, background: "#fff", borderRadius: "10px", boxShadow: "0px 4px 10px rgba(0,0,0,0.1)", width: "100%" }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, m: 3 }}>
                    Course Curriculum
                  </Typography>


                  {courseModules && courseModules?.length > 0 && courseModules?.map((module, i) => {
                    const isModuleCompleted =
                      module?.subModule?.length > 0 &&
                      module.subModule.every((sm) => sm.completed === 100);
                    return (
                      <Accordion
                        key={i}
                        expanded={expanded === i}
                        ref={(el) => (accordionRefs.current[i] = el)}
                        onChange={() => handleChange(i)}
                        sx={{
                          border: "1px solid #E0E0E0",
                          borderRadius: "12px",
                          boxShadow: "none",
                          overflow: "hidden",
                          mb: 2,
                          width: "95%",
                          mx: "auto",
                          px: 2,
                          py: 1.8,
                          minHeight: "60px !important",
                          ...(expanded === i && i === 0
                            ? { marginLeft: "36px" }
                            : {})
                        }}
                      >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}
                          sx={{ height: "60px", display: "flex", alignItems: "center" }}>
                          <Box sx={{ mt: 2, mb: 2 }}>
                            <div className="flex items-center space-x-3">
                              {isModuleCompleted ? <CheckCircleIcon style={{ color: '#32D74B' }} className="w-7 h-7 mb-3" /> :
                                <div className="w-7 h-7 bg-gray-200 rounded-full flex items-center justify-center font-semibold">
                                  {i + 1}
                                </div>}
                              <div className="flex flex-col leading-tight">
                                <p className="font-semibold">{module?.courseModuleName}</p>
                                <p className="text-xs text-gray-500 mt-2">{module?.subModule?.length} Sub Modules</p>
                              </div>
                            </div>
                          </Box>
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 0, overflow: "hidden", borderTop: "1px solid #eee" }}>
                          <List sx={{ width: "100%", m: 0, p: 0 }}>
                            {module?.subModule?.map((subModule, idx) => (
                              <ListItem button key={idx} onClick={() => setSelectedLesson(`${i}-${idx}`)} sx={{ py: 1.2, px: 2, display: "flex", alignItems: "center", borderBottom: "1px solid #f1f1f1", backgroundColor: selectedLesson === `${i}-${idx}` ? "#EFFFF6" : "transparent", }}>
                                <IconButton><VideoCameraIcon style={{ color: subModule?.completed === 100 ? '#32D74B' : subModule?.completed > 0 ? '#FFA500' : 'black' }} className="w-6 h-6 text-black" /></IconButton>
                                <span
                                  onClick={() => { ((obj && obj?.length === 0 || obj?.length === 1 && obj[0]?.isSubscribed === false || isValid === false) && courseDetails?.is_free === false && userRole !== 'AUTH_USER') ? alert("Please Subscribe the course") : handleStartSimulation(subModule?.id, courseModules[expanded]?.courseModuleName, expanded, courseModules) }}
                                  style={{ fontSize: "14px", marginLeft: "12px", cursor: "pointer", color: 'black', textDecoration: 'underline' }}>{subModule?.courseSubmoduleName}</span>
                                <IconButton sx={{ ml: "auto" }}>
                                  {subModule?.completed === 100 ? <CheckCircleIcon style={{ color: '#32D74B' }} className="w-6 h-6 mb-3" /> : subModule?.completed > 0 ? <ClockIcon style={{ color: '#FFA500' }} className="w-6 h-6 mb-3" /> : ""}
                                </IconButton>

                              </ListItem>
                            ))}
                          </List>
                        </AccordionDetails>
                      </Accordion>
                    )
                  }
                  )}
                </Box>

              </div>
              <div className="hidden md:block flex-shrink-0" style={{ width: '60%', height: '100%', paddingRight: '30px' }}>
                {showAiPanel && (
                  <div className="hidden md:flex flex-col flex-1 h-full" style={{ paddingRight: '30px' }}>
                    <CourseAIAssistant
                      courseId={courseDetails?.id}
                      courseName={courseDetails?.title}
                      inline={true}
                      initialQuestionsFromParent={aiInitialQuestions}
                      kbStatusFromParent={aiKbStatus}
                      onNavigateToModule={handleAiNavigateToModule}
                    />
                  </div>
                )}

              </div>
            </div>
            {showAiPanel && (
              <div className="md:hidden">
                <CourseAIAssistant
                  courseId={courseDetails?.id}
                  courseName={courseDetails?.title}
                  inline={false}
                  initialQuestionsFromParent={aiInitialQuestions}
                  kbStatusFromParent={aiKbStatus}
                  onNavigateToModule={handleAiNavigateToModule}
                />
              </div>
            )}
            {!showAiPanel && (
              <div style={{ display: 'none' }}>
                <CourseAIAssistant
                  courseId={courseDetails?.id}
                  courseName={courseDetails?.title}
                  inline={false}
                  onKbStatus={setShowAiPanel}
                />
              </div>
            )}
          </>
        }

        {coursetabIndex === 2 &&
          <>
            {courseDetails?.is_free === false && (
              <>
                <h2 className="text-2xl font-semibold mb-6 ml-5">Certifications</h2>

                <div className="w-[97%] mx-auto border border-[#CCCCCC] rounded-lg p-4 shadow-sm">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">

                    <div>
                      <h2 className="text-lg font-semibold text-gray-800">
                        {courseDetails?.title} Certificate
                      </h2>
                    </div>

                    <button
                      onClick={() =>
                        courseProgress?.course_certificate_url &&
                        downloadURINew(courseProgress.course_certificate_url, "pdf")
                      }
                      disabled={!courseProgress?.course_certificate_url}
                      className={`w-full sm:w-auto flex items-center justify-center gap-2 border text-sm font-medium px-4 py-2 rounded transition ${courseProgress?.course_certificate_url
                          ? "border-yellow-400 text-gray-700 hover:bg-yellow-400/20 cursor-pointer"
                          : "border-gray-300 text-gray-400 cursor-not-allowed opacity-60"
                        }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        className="w-4 h-4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 16V4m0 12l4-4m-4 4l-4-4m12 8H4"
                        />
                      </svg>
                      Download Now
                    </button>

                  </div>
                </div>
              </>
            )}

            <div className="w-full p-6">
              <h2 className="text-2xl font-semibold mb-6">Achievements</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {achievements.map((item, index) => (
                  <div
                    key={index}
                    className={`p-5 rounded-xl border shadow-sm transition duration-200
           flex flex-col items-center text-center gap-1
           ${item.unlocked ? "bg-[#FFF6E9] border-transparent" : "bg-gray-100 opacity-60"}
         `}
                  >
                    <img src={item.icon} alt="badge" className="w-28 h-28 object-contain" />
                    <h3 className="text-lg font-semibold">{item.title}</h3>
                    <p className="text-sm text-gray-600">{item.desc}</p>
                    <div className="flex items-start gap-2 mt-2 text-sm font-medium">
                      {item.unlocked ? (
                        <>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className="w-4 h-4 mt-0.5 shrink-0 text-yellow-600"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M13.5 10.5V6.75a4.5 4.5 0 1 1 9 0v3.75M3.75 21.75h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H3.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                            />
                          </svg>

                          <span className="text-yellow-600 text-xs leading-5">
                            Congratulations! You have unlocked it!
                          </span>
                        </>
                      ) : (
                        <>
                          <span className="text-gray-500 shrink-0">🔒</span>
                          <span className="text-gray-500 leading-5">Locked</span>
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </>



        }


      </Grid>

      {userRole !== 'AUTH_USER' &&
        !subscription?.isTrial &&
        (subscription?.isSubscribed || subscription?.planStatus?.toLowerCase() === 'active') && <CaseStudyHtml />}

      {userRole === 'AUTH_USER' &&
        subscription?.isSubscribed &&
        subscription?.planStatus?.toLowerCase() === 'active' && <CaseStudyHtml />}

      <BasicModal openModel={openResult} closeModel={() => setOpenResult(!openResult)} title="Case study result">
        <Typography variant="h5" gutterBottom sx={{ display: 'flex' }}>
          Test Result :{' '}
          {csTestResult && csTestResult.result ? (
            <Typography variant="h5" color="secondary">
              &nbsp;Pass
            </Typography>
          ) : (
            <Typography variant="h5" color="primary">
              &nbsp; Fail
            </Typography>
          )}
        </Typography>
        <Typography variant="body1" gutterBottom>
          Percentage : {csTestResult && csTestResult.resultInPercentage} %
        </Typography>
        {/* <Typography variant="body1" gutterBottom>
          Time Taken : {csTestResult && csTestResult.timeTaken}
        </Typography> */}
        <Typography variant="body1" gutterBottom>
          Correct Answer: {csTestResult && csTestResult.rightAnswer}
        </Typography>
        <Typography variant="body1" gutterBottom>
          Wrong Answer: {csTestResult && csTestResult.wrongAnswer}
        </Typography>
        <Typography variant="body1" gutterBottom>
          Total number of question: {csTestResult && csTestResult.totalScreen}
        </Typography>
      </BasicModal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openVideoModal}
        onClose={handleClose}
        closeAfterTransition
        sx={{
          backgroundColor: '#0a00008c !important',
          '.css-moysu4': {
            border: 'none !important',
          },
        }}
      >
        <Fade in={openVideoModal}>
          <Box className={classes.vediobox}>
            <Typography variant="h6" color="#fff" gutterBottom>
              {videoTitle.title}
            </Typography>
            <IKContext urlEndpoint={['dev', 'test'].includes($(process.env.REACT_APP_ENV)) ? process.env.REACT_APP_AWS_S3_URL : ImageKit.ImageKitUrl} isPrivateFile>
              <IKVideo
                ref={videoRef}
                className={classes.videoContainer}
                src={videoTitle.video}
                controls={true}
                controlsList="nodownload"
              />

            </IKContext>
            <IconButton
              sx={{
                position: 'absolute',
                top: '24px',
                background: '#f6f6f6',
                // '.css-3u56ba-MuiButtonBase-root-MuiIconButton-root:hover': {
                //   backgroundColor: 'rgb(255 255 255 / 67%) !important',
                // },
              }}
              className={classes.closeBtn}
              size="small"
              onClick={() => setOpenVideoModal(false)}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </Fade>
      </Modal>


      <Dialog fullWidth open={openMobieViewError}>
        <DialogTitle style={{ color: "#FE7000", textAlign: 'center', paddingBottom: '0px', fontSize: '18px', fontWeight: '900', paddingTop: '22px' }}>Desktop Only!</DialogTitle>
        <CloseIcon onClick={() => setOpenMobileViewError(false)} sx={{ position: 'absolute', right: '0', padding: '5px', fontSize: '36px', marginRight: '5px', marginTop: '5px', fontWeight: '800', color: '#000' }} fontSize="small" />
        <DialogContent style={{ fontSize: '13px', textAlign: 'center', fontWeight: '750', lineHeight: '1.18', color: '#000', padding: '15px 15px 0px' }}>Our Guided-Simulation Learning Platform is best viewed on Desktop only. If you are using a Mobile device, we suggest you shift to a laptop or PC to upskill well!</DialogContent>
        <DialogActions sx={{ justifyContent: 'center', justifyContent: 'center', paddingBottom: '15px' }}>
          <Button sx={{ letterSpacing: '1.3px' }} onClick={() => setOpenMobileViewError(false)}>START LEARNING BETTER!</Button>
        </DialogActions>
      </Dialog>

      <MobileRestrictionDialog
        open={showMobileRestrictionDialog}
        onClose={() => setShowMobileRestrictionDialog(false)}
      />
      <Footer />
    </Page>
  );
}


const useStyles = makeStyles((theme) => ({
  subscribe: {
    color: '#FFFFFF',
    backgroundColor: '#00B673',
    padding: '9px 18px',
    borderRadius: '20px',
    fontWeight: '400',
    '&:hover': {
      backgroundColor: '#00B673',
    },
  },
  closeBtn: {
    '&:hover': {
      backgroundColor: 'rgb(255 255 255 / 67%)',
    },
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    minHeight: {
      xs: '300px',  // Mobile
      sm: '380px',  // Tablet
      md: '455px'   // Desktop
    },
    maxHeight: {
      xs: '300px',
      sm: '380px',
      md: '455px'
    },
    border: '2px solid #ccc',
    borderRadius: '8px',
    backgroundImage: `url(${require('../../../assets/Images/shapeachivement.png')})`,
    backgroundPositionY: '-19px',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    width: '100%',

  },
  banner: {
    dispaly: 'flex',
    justifyContent: 'space-between',
  },
  renewContent: {
    flexDirection: 'column',
    justifyContent: 'center',
    display: 'flex',
    height: '103px',
  },
  paper1: {
    padding: '16px',
    marginTop: -18,
    textAlign: 'center',
    marginBottom: '1rem',
    [theme.breakpoints.down('md')]: {
      marginBottom: '1rem',
    },
  },
  cardItem: {
    marginBottom: '24px',
    border: '1px solid #e1e1e1ab',
  },
  resumeBox: {
    width: '140px',
    padding: '8px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  courserContent: {
    margin: '8px 0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  infoIcon: {
    color: 'gray',
    marginLeft: '8px',
  },
  progress: {
    width: '42%',
    marginBottom: '0.9rem',
  },
  courseBtn: {
    width: 'max-content',
    background: ' #fff',
    padding: '4px 8px',
    borderRadius: '6px',
  },
  logo: {
    boxShadow: '0px 3px 22px #00000029',
    padding: '1px',
    width: '35px',
    borderRadius: '6px',
    '@media (min-width: 1200px)': {
      marginRight: '-90px!important',
    },
  },


  category: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  categoryPosition: {
    position: 'relative',
    top: '13rem',
  },
  coursecard: {
    position: 'relative',
    minHeight: '20rem',
    // marginLeft: 30,
    // marginRight: 30,
    // marginTop: 20,
    backgroundColor: '#fff !important',

    // padding: '2rem',
    borderRadius: '6px',
    [theme.breakpoints.down('md')]: {
      minHeight: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '1rem',
    },
    '@media screen (max-width: 500px)': {
      marginRight: '15px',
      marginLeft: '15px'
    }
  },
  videoContainer: {
    width: '100%',
  },
  coursetitle: {
    overflow: 'hidden',
    color: 'black',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: {
      xs: 3,          // Mobile shows 3 lines
      sm: 2,          // Tablet shows 2 lines
      md: 2           // Desktop shows 2 lines
    },
    WebkitBoxOrient: 'vertical',
    fontSize: {
      xs: '1rem',     // Mobile
      sm: '1.1rem',   // Tablet
      md: '1.2rem'    // Desktop
    },
  },
  efficiencyScore: {
    textAlign: 'center',
    marginTop: '-26px',
    '@media (max-width: 768px)': {
      marginTop: '-20px',
    },
    '@media (max-width: 576px)': {
      marginTop: '-15px',
    },
  },
  efficiencyText: {
    fontSize: {
      xs: '0.9rem',
      sm: '1rem',
      md: '1.1rem'
    },
    fontWeight: '600',
    lineHeight: 1.5,
  },
  efficiencyLabel: {
    fontSize: '0.9rem',
    '@media (max-width: 768px)': {
      fontSize: '0.8rem',
    },
    '@media (max-width: 576px)': {
      fontSize: '0.7rem',
    },
  },


  content: {
    minHeight: '12rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: '10',
    WebkitBoxOrient: 'vertical',
    color: '#fff',
    fontWeight: '200',
    margin: '1rem 0rem 1.5rem 0rem',
    [theme.breakpoints.down('lg')]: {
      minHeight: '13rem',
    },
    '@media (max-width: 1040px)': {
      minHeight: '10rem',
    },
  },
  resume: {
    color: '#000000',
    fontWeight: '450',
    backgroundColor: '#fff',
    fontSize: '14px',
    borderRadius: '6px',
    padding: '2.5px 8px',
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
    '&:hover': {
      backgroundColor: '#fff',
    },
  },
  powerpoint: {
    backgroundColor: '#fff',
    fontSize: '14px',
    color: '#02723B',
    borderRadius: '6px',
    padding: '7px 8px',
    width: 'fit-content',
    margin: '0px 12px',
    marginTop: '10px',
  },

  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '10px',
  },

  courseImg: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '350px',
    position: 'relative',
    overflow: 'hidden',
    margin: 0,
    padding: 0,
  },
  imagebox: {
    padding: '6px',
    marginTop: '1rem',
    backgroundImage: `url(${background})`,
    borderRadius: '8px',
    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  halfRow: {
    width: '50%',
  },
  center: {
    alignItems: 'center',
    width: '100%',
  },
  // courseImg: {
  //   display: 'flex',
  //   flexDirection: 'column',
  //   // alignItems: 'center',
  //   // justifyContent: 'center',
  //   alignItems: 'flex-start',
  //   justifyContent: 'flex-start',
  //   width: '100%', // Ensure the container takes the full width
  //   margin: '0', // Reset any margins that may cause centering
  //   padding: '0', // Reset any padding 
  // },
  play: {
    padding: '0px ! important',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  vedio: {
    height: '100%',
    width: '100%',
  },
  vediobox: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    height: 'auto',
    bgcolor: 'background.paper',
    padding: '20px',
    boxShadow: 24,
    p: 4,
  },
  iqbox: {
    display: 'flex',
    padding: {
      xs: '10px',
      sm: '10px 20px',
      md: '10px 50px 10px 10px'
    },
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: {
      xs: '10px',
      sm: '15px',
      md: '20px'
    }
  },
  assesment: {
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      margin: '12px 0px',
    },
  },
  iqbutton: {
    padding: '8px',
    fontSize: '0.95rem',
    fontWeight: ' bold',
    [theme.breakpoints.down('sm')]: {
      margin: 'auto',
    },
  },
  videoIcon: {
    padding: '0px',
  },
  fileList: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.5rem 1rem',
    background: '#F5F5F5',
    borderRadius: '10px',
    marginBottom: '0.8rem',
  },
  showMoreText: {
    minHeight: '14rem',
    display: '-webkit-box',
    WebkitLineClamp: 11,
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical',
    color: '#fff ! important',
  },
  textcolor: {
    minHeight: '14rem',
    maxHeight: '14rem',
    color: '#fff ! important',
    overflow: 'scroll',
    WebkitLineClamp: 11,
    WebkitBoxOrient: 'vertical',
    // display: '-webkit-box',
  },
  readMore: {
    width: 'max-content',
    cursor: 'pointer',
  },
  CourseButton: {
    width: 70,
    color: '#6a6e6b', // initial text color
    border: '1px solid #6a6e6b', // initial border color
    borderRadius: '6px',
    fontSize: '12px',
    backgroundColor: 'white',
    '&:hover': {
      color: '#00B673', // text color on hover
      border: '1px solid #00B673', // border color on hover
      backgroundColor: 'white',
    },
  },
  searchtabsgrid: {
    display: 'flex',
    justifyContent: 'center',
  },
  playbtn: {
    width: '60px',
    height: '60px',
    background: 'radial-gradient( gree 60%, rgba(255, 255, 255, 1) 62%)',
    borderRadius: '50%',
    position: 'relative',
    display: 'block',
    // margin: "100px auto",
    boxShadow: '0px 0px 25px 3px rgba(255, 0, 128, 0.8)',
    ':after': {
      content: '',
      position: 'absolute',
      left: '50%',
      top: '50%',
      webkitTransform: 'translateX(-40%) translateY(-50%)',
      transform: 'translateX(-40%) translateY(-50%)',
      transformOrigin: 'center center',
      width: '0',
      height: '0',
      borderTop: '10px solid transparent',
      borderBottom: '10px solid transparent',
      borderLeft: '15px solid #fff',
      zIndex: '100',
      webkitTransition: 'all 400ms cubic-bezier(0.55, 0.055, 0.675, 0.19)',
      transition: 'all 400ms cubic-bezier(0.55, 0.055, 0.675, 0.19)',
    },
    ':before': {
      content: '',
      position: 'absolute',
      width: '140%',
      height: '140%',
      webkitAnimationDelay: '0s',
      animationDelay: '0s',
      webkitAnimation: 'pulsate1 2s',
      animation: 'pulsate1 2s',
      webkitAnimationDirection: 'forwards',
      animationDirection: 'forwards',
      webkitAnimationIterationCount: 'infinite',
      animationIterationCount: 'infinite',
      webkitAnimationTimingFunction: 'steps',
      animationTimingFunction: 'steps',
      opacity: '1',
      borderRadius: '50%',
      border: '5px solid rgba(255, 255, 255, .75)',
      top: '-30%',
      left: '-30%',
      background: 'rgba(198, 16, 0, 0)',
    },
  },

  renewContent: {
    flexDirection: 'column',
    justifyContent: 'center',
    display: 'flex',
    height: '90px',
  },
  iconifystyle: {
    // color: '#63B182',
    minWidth: '51px',
    height: '65px',
  },
  playbutton: {
    backgroundColor: 'unset !important',
    position: 'absolute',
    top: '40%',
    left: '42%',
    display: {
      xs: 'none',     // Hidden on mobile
      sm: 'block',    // Show on tablet and up
    },
    top: {
      sm: '44%',      // Tablet
      md: '50%'       // Desktop
    },
    left: {
      sm: '10%',      // Tablet
      md: '15%'       // Desktop
    },
    '&:hover': {
      backgroundColor: 'unset !important',
    },
  },
  progressbarcontainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },

  stepcontainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '10px',
  },

  step: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: '1',
    position: 'relative',
  },

  steplabel: {
    marginTop: '5px',
    fontSize: '12px',
  },

  completed: {
    color: 'green',
  },

  progressline: {
    position: 'relative',
    width: '100%',
    height: '5px',
    backgroundColor: '#009A31',
    borderRadius: '5px',
  },

  progressfill: {
    height: '100%',
    borderRadius: '5px',
  },


  glowing: {
    padding: '0px',
    borderRadius: '50%',
    animation: '$pulse 1.5s infinite',
  },

  progressSection: {
    '@media screen (max-width: 500px)': {
      marginBottom: '55px'
    }
  },


  subModuleSec: {
    '@media (max-width: 500px)': {
      margin: '5px',
    },

  },
  paddingZero: {
    '@media (max-width: 500px)': {
      padding: '5px',
      paddingBottom: '8px'
    },

  },
  fontdetailstxt: {
    '@media (max-width: 500px)': {
      display: 'flex',
      flexDirection: 'column'
    },
  },

  gridA: {
    width: 'calc(100% - 360px)',
  },
  CourseContentSec: {
    marginLeft: '30px',
    marginRight: '30px',
    marginTop: '40px',
    width: 'initial',
    '@media (max-width: 800px)': {
      marginLeft: '15px'
    }
  },

  '@media (max-width: 992px)': {
    gridA: {
      width: '100% !important',
      overflowY: 'auto'
    },
    gridB: {
      width: '350px',
      marginTop: '30px'
    },
    gridBsub: {
      paddingLeft: '0px !important'
    }

  },


  '@global': {
    '.MuiAccordion-root.Mui-expanded': {
      marginLeft: '10px',

      [theme.breakpoints.up('sm')]: {
        marginLeft: '15px',
      },
      [theme.breakpoints.up('md')]: {
        marginLeft: '20px',
      },
      [theme.breakpoints.up('lg')]: {
        marginLeft: '34px',
      },
      [theme.breakpoints.up('xl')]: {
        marginLeft: '40px',
      },
    },
    '@keyframes pulse': {
      '0%': {
        transform: 'scale(0.95)',
        boxShadow: '0 0 0 0 rgba(0, 0, 0, 0.7)',
      },
      '70%': {
        transform: 'scale(1)',
        boxShadow: '0 0 0 10px rgba(0, 0, 0, 0)',
      },
      '100%': {
        transform: 'scale(0.95)',
        boxShadow: '0 0 0 0 rgba(0, 0, 0, 0)',
      },
    },
    '@keyframes slide': {
      '0%': {
        transform: 'translateX(100%)'
      },
      '100%': {
        transform: 'translateX(-100%)'
      }

    },
  },
}));